<script>
import logoWhite from '@/assets/logo-white.png'

export default {
  props: {
    title:    { type: String, default: '' },
    subtitle: { type: String, default: '' },
  },
  data() {
    return { logo: process.env.VUE_APP_LOGO_LIGHT || logoWhite }
  },
}
</script>

<template>
  <header class="hero">
    <div class="hero__logo">
      <img :src="logo" alt="Axen Energia" />
    </div>
  </header>
</template>
